<template>
  <div class="dialogBox">
    <el-dialog
      v-for="(item, index) in dialogData"
      :key="item.key ||item.name|| index"
      :class="item.className||item.name||'dialogClassName'"
      :visible.sync="item.isDialog"
      :width="item.width || '30%'"
      :lock-scroll='item.lockScroll'
      :close-on-click-modal='item.closeModal'
      :close-on-press-escape='item.closePressEscape'
      :show-close='item.showClose'	
      :append-to-body="item.isAppendToBody"
      :before-close="handleClose(item.name)"
      @closed="handleCloseFn(item.colseFn)"
    >
      <div slot="title" class="dialog-title" style="userselect: none">
        <i class="el-icon-postcard"></i>
        <span>{{ item.title || "默认标题" }}</span>
      </div>
      <slot :name="item.name" :scope="item || item.data"> 默认dialog内容 </slot>
      <div slot="footer" class="dialog-footer" v-if="item.isBtn">
        <el-button @click="cancel(item.handleClickCancel,item,index)" :icon="item.iconCancel?item.iconCancel:''" :loading='item.isLoadingCancel'
          >{{item.cancelBtnName?item.cancelBtnName:'取 消'}}</el-button
        >
        <el-button v-if="!item.isConfirmBtnHide" type="primary" @click="item.handleClickConfirm(item, index,confirm)" :icon="item.iconConfirm?item.iconConfirm:''" :loading='item.isLoadingConfirm'
          >{{item.confirmBtnName?item.confirmBtnName:'确定'}}</el-button
        >
        <el-button v-if="item.isCustom" type="primary" @click="item.handleClickCustom(item, index,confirm)" :icon="item.iconCustom?item.iconCustom:''" :loading='item.isLoadingCustom'
          >{{item.customBtnName?item.customBtnName:'自定义'}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openDialog(key){
      let arr=[...this.dialogData];
      arr=arr.map(item=>{
        if(item.name===key){
          item.isDialog=true
        }
        return item
      })
      this.$emit('update:dialogData',arr)
    },
    cancel(cancelFn,item,index){
      if(cancelFn) return cancelFn(item,index)
      // console.log(2)
      let arr=[...this.dialogData];
      arr[index].isDialog=false
      this.$emit('update:dialogData',arr)
    },
    confirm(index){
      let arr=[...this.dialogData];
      arr[index].isDialog=false
      this.$emit('update:dialogData',arr)
    },
    handleCloseFn(closeFn){
      if(closeFn) closeFn()
    },
    //关闭前的回调
    handleClose(name) {
      this.$emit("handleClose", name);
    },
    //Dialog 关闭动画结束时的回调
    handleReset() {
      this.$emit('handleReset')
      // this.$refs.form.resetFields();
    },
  },
  //   //dialog数据源
  //   dialogData: [
  //     {
  //       data:[],//传递数据slot
  //       name: "audit", //dialog插槽名
  //       key: "audit", //区分唯一性key
  //       isDialog: false, //是否显示dialog
  //       isBtn: true, //是否显示cancel和confirm按钮
  //       title: "提示", //header提示内容
  //       width: "50%", //dialog宽度
  //       handleClickCancel: this.handleAuditCancel, //dialog取消
  //       handleClickConfirm: this.handleAuditConfirm, //dialog确定
  //       isAppendToBody:true//是否是内层dialog
  //       colseFn:this.importClosed||null,//关闭回调,无则传null
  //       iconCancel:'el-icon-circle-close',//cancel图标
  //       iconConfirm:'el-icon-circle-check',//confirm图标
  //       isLoadingConfirm:false,//是否confirm loading 开启
  //     },
  //   ],
  //使用
  // <PublicDialog :dialogData='dialogData'>
  //     <template #audit='{scope}'>
  //     <span>{{scope}}</span>
  //     </template>
  // </PublicDialog>

  // handleAuditCancel(item,index){
  //     console.log(1)
  //     this.dialogData[index].isDialog=false
  // },
  // handleAuditConfirm(item,index){
  //     console.log(2)
  //     this.dialogData[index].isDialog=false
  // },
  // handleClickTest(){
  //     axios.get('/hua.json')
  //     .then(res=>{
  //     console.log(res)
  //     })
  //     this.dialogData[0].isDialog=true
  // },
};
//请求json文件
// import axios from 'axios'
//  axios.get('/hua.json')
//       .then(res=>{
//         console.log(res)
//       })
// 文件路径
// public/hua.json
</script>
